module.exports = __webpack_public_path__ + "img/sy_n2.f4d4b0a6.jpg";